<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <h5 class="mb-0">Liste des Vérifications</h5>
      </div>
      <div class="d-flex align-items-center">
        <Field name="total" v-model="leTotal" aria-disabled="true" type="text" disabled
          class="form-control text-center text-black shadow-none fs-md-15 text-black" />
      </div>
      <div class="d-flex align-items-center">
        <button type="button" @click="getExport()" v-if="valideEtape3"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none">
          <i class="flaticon-download position-relative ms-5 fs-12"></i>
          Exporter
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" v-if="!valideEtape3" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-3 col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mot clé
              </label>
              <Field v-model="motCle" name="mot" type="text" aria-disabled="true"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
              <ErrorMessage name="mot" class="text-danger" />
            </div>
          </div>
          <div class="col-md-3 col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Agent <span class="text-danger">*</span>
              </label>
              <Field name="agent" v-slot="{ field }" v-model="agent"
                class="form-control shadow-none fs-md-15 text-black">
                <Multiselect v-model="field.value" v-bind="field" :options="agentOptions" :searchable="true"
                  noResultText="Aucun enregistrement trouvé" placeholder="Rechercher un agent" />
              </Field>
              <ErrorMessage name="agent" class="text-danger" />
            </div>
          </div>

          <div class="col-md-3 col-sm-6col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date début <span class="text-danger">*</span>
              </label>
              <Field name="dateDebut" type="date" v-model="dateDebut"
                class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="dateDebut" class="text-danger" />
            </div>
          </div>

          <div class="col-md-3 col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date fin <span class="text-danger">*</span>
              </label>
              <Field name="dateFin" v-model="dateFin" type="date"
                class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="dateFin" class="text-danger" />
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                #
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Code
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                NPI
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Répété ?
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Existant ?
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Agent
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(verification, index) in verifications" :key="index">
              <td class="shadow-none lh-1 fw-medium text-primary">
               {{index + 1}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ truncateCode(verification.code) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ verification.npi || '' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span class="badge" :class="verification.repeter ? 'badge-warning' : 'badge-success'">
                  {{ verification.repeter ? 'Oui' : 'Non' }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span class="badge" :class="verification.enroler ? 'badge-success' : 'badge-danger'">
                  {{ verification.enroler ? 'Oui' : 'Non' }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ verification.agentResponsable?.nomComplet || 'N/A' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_date(verification.createdAt) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <div class="dropdown">
                  <span class="badge text-white bg-secondary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <a @click="viewVerification(verification)" href="javascript:void(0);" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                        Voir détails
                      </a>
                    </li>
                    <li v-if="checkPermission('DeleteVerification')">
                      <a href="javascript:void(0);" data-bs-target="#delete-modal" data-bs-toggle="modal"
                        @click="openDeleteModal(verification.id)" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-trash lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <!-- Modal de suppression -->
      <div class="modal fade" id="delete-modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Voulez-vous supprimer cette vérification ?</h6>
              <button type="button" id="close-delete-modal" class="btn-close" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div class="modal-body px-4">
              <p>Cette action est irréversible.</p>
            </div>
            <div class="modal-footer">
              <button type="button" @click="deleteVerification" class="btn btn-danger">Supprimer</button>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted, watch } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import {
  showModal,
  suppression,
  separateur,
  format_Date,
  format_date,
  supprimerElement,
  error,
  dateActuelle,
  success,
  checkPermission,
  getUrlApiForFiles,
} from "@/utils/utils";
import ApiService from "@/services/ApiService";
import { Option } from "@/models/Option";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import JwtService from "@/services/JwtService";
import Multiselect from "@vueform/multiselect";
import axios from "axios";
import Swal from "sweetalert2";
import * as Yup from 'yup';
import RecensementDashboard from "@/pages/Dashboard/RecensementDashboardPage.vue";

export default defineComponent({
  name: "ListeVerification",
  components: {
    PaginationComponent,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup: () => {
    // BEGIN PAGINATE
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const motCle = ref("");
    const dateFin = ref(dateActuelle());
    const dateDebut = ref(dateActuelle());
    const leTotal = ref("0");
    const donn = ref();
    const verificationId = ref<number | null>(null);

    // END PAGINATE
    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        actionRecherche(page_, limit_);
      } catch (error) {
        //
      }
    };

    const getUser = async () => {
      try {
        const response = await axios.get("/tout/users");
        const donnee = response.data.data;
        agentOptions.value = donnee.map((agent) => ({
          value: agent.id,
          label: agent.nomComplet,
        }));
      } catch (error) {
        //
      }
    };

    function triggerButtonClick(buttonId: string) {
      const button = document.getElementById(buttonId) as HTMLButtonElement;
      if (button) {
        button.click();
      } else {
        console.error(`Button with ID "${buttonId}" not found.`);
      }
    }

    const valideEtape3 = ref(true);
    const recharger = () => {
      actionRecherche(page.value, limit.value);
    };
    const agent = ref();
    const agentOptions = ref();
    const verifications: any = ref<Array<any>>([]);

    const openDeleteModal = (id: number) => {
      verificationId.value = id;
    };

    const deleteVerification = async () => {
      if (!verificationId.value) return;
      
      try {
        const response = await ApiService.delete(`/verification/${verificationId.value}`);
        if (response.data.success) {
          success("Vérification supprimée avec succès");
          await actionRecherche(1, 10);
          triggerButtonClick("close-delete-modal");
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const viewVerification = (verification: any) => {
      Swal.fire({
        title: 'Détails de la vérification',
        html: `
          <div class="text-left">
            <p><strong>ID:</strong> ${verification.id}</p>
            <p><strong>Code:</strong> ${verification.code}</p>
            <p><strong>NPI:</strong> ${verification.npi || 'N/A'}</p>
            <p><strong>Répété:</strong> ${verification.repeter ? 'Oui' : 'Non'}</p>
            <p><strong>Enrôlé:</strong> ${verification.enroler ? 'Oui' : 'Non'}</p>
            <p><strong>Agent:</strong> ${verification.agentResponsable?.nom || 'N/A'}</p>
            <p><strong>Date:</strong> ${format_date(verification.createdAt, '')}</p>
          </div>
        `,
        confirmButtonText: 'Fermer'
      });
    };

    const truncateCode = (code: string) => {
      if (!code) return 'Aucun code';
      return code.length > 20 ? code.substring(0, 20) + '...' : code;
    };

    const actionRecherche = async (page = 1, limi = 10, searchTerm = "") => {
      const element = {
        dateDebut: (dateDebut.value ? dateDebut.value : dateActuelle()) + " 00:00:00",
        dateFin: (dateFin.value ? dateFin.value : dateActuelle()) + " 23:59:59",
        motCle: motCle.value,
        recherche: motCle.value,
        agent: agent.value,
        page: page,
        totalPages: totalPages.value,
        limit: limi,
        totalElements: totalElements.value,
        mot: searchTerm,
      };
      donn.value = element;
      try {
        const response = await axios.post("verifications", element);
        verifications.value = response.data.data;
        totalPages.value = response.data.pagination.totalPages;
        limit.value = response.data.pagination.limit;
        totalElements.value = response.data.pagination.totalElements;
        leTotal.value = separateur(response.data.data.total) + " (Vérifications)";
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const getExport = async () => {
      try {
        valideEtape3.value = false;
        donn.value = {
          dateDebut: (dateDebut.value ? dateDebut.value : dateActuelle()) + " 00:00:00",
          dateFin: (dateFin.value ? dateFin.value : dateActuelle()) + " 23:59:59",
          motCle: motCle.value,
          agent: agent.value,
        };
        const response = await axios.post("/verification/export/excel", donn.value);
        // Télécharger le fichier
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'verifications.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);
        valideEtape3.value = true;
      } catch (err: unknown) {
        if (err instanceof Error) {
          error("Erreur lors de l'export: " + err.message);
        } else {
          error("Erreur lors de l'export");
        }
        valideEtape3.value = true;
      }
    };

    // Watchers
    watch(motCle, async (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      motCle.value = newValue;
      await actionRecherche(page.value, limit.value);
    });

    watch(dateFin, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      dateFin.value = newValue;
      actionRecherche(page.value, limit.value);
    });

    watch(agent, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      agent.value = newValue;
      actionRecherche(page.value, limit.value);
    });

    watch(dateDebut, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      dateDebut.value = newValue;
      actionRecherche(page.value, limit.value);
    });

    onMounted(async () => {
      await actionRecherche(1, 10);
      await getUser();
    });

    return {
      dateDebut,
      dateFin,
      suppression,
      recharger,
      page,
      agentOptions,
      agent,
      viewVerification,
      verifications,
      totalPages,
      limit,
      format_date,
      format_Date,
      separateur,
      totalElements,
      handlePaginate,
      searchTerm,
      motCle,
      error,
      leTotal,
      checkPermission,
      getExport,
      valideEtape3,
      dateActuelle,
      openDeleteModal,
      deleteVerification,
      truncateCode,
    };
  },
});
</script>
